<template>
    <v-row class="ma-0 pb-offset">
		<v-col class="pa-0" cols="12">
            <v-card class="mb-2 background-2 round-card" ref="notificationssetting">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Impostazioni</p>
                    <v-spacer></v-spacer>
                </v-card-title> 
                <v-divider></v-divider>
                <v-subheader class="pl-4">Prodotto Telefonia</v-subheader>
                <v-list three-line subheader class="background-2 pa-2">
                    <v-list-item class="my-0">
                        <v-list-item-content>
                            <v-list-item-title>Seleziona il prodotto da utilizzare nei documenti per il Consumo Voce</v-list-item-title>
                            <v-list-item-subtitle>
                                <v-col cols="12" sm="12" md="8" lg="3" class="pl-0">
                                    <v-autocomplete
                                        :items="products"
                                        label="Prodotti"
                                        v-model="settings['product_id']"
                                        single-line
                                        item-text="text"
                                        item-value="id"                                        
                                        dense
                                        small-chips
                                        outlined
                                    ></v-autocomplete>
                                </v-col>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
					<v-btn text class="pa-2 mx-2" color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>
                                
            </v-card>
        </v-col>
    </v-row>
</template>


<script>
    import Vue from 'vue'
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin';

    export default {
        name: 'subscriptions-options',
        mixins: [SettingsOptionsMixin],
        props: {},
        data() {
            return {
                model: 'subscription',
                settings: {
                    'product_id': null,
                },
                products: []
            }
        },


        created() {
            this.axios.get('settings/'+this.model).then(response => {

                _.forEach(response.data.settings, (setting) => {
                    Vue.set(this.settings, setting.key, setting.value)
                })

                this.axios.post('getoptionfields/', {model: 'Product', value: 'id', relation_field: 'name', key: 'text'}).then(response => {
                    
                    this.products = response.data.option_fields
                    this.$store.commit('endProgress')

                }, response => {
                    // error callback
                })

            

            }, response => {
                // error callback
            })
        }

    }
</script>